import React, { Component } from 'react';
import { withRouter } from 'react-router'
import JwtDecode from 'jwt-decode';
import Cookies from 'cookies-js';
import Constants from './Constants.js';

class Base extends Component {

  componentWillMount() {

    if( Cookies.get('jwtsession') ) {
      var tokenPayload = JwtDecode(Cookies.get('jwtsession'));
      this.sessionData = tokenPayload;
      this.props.router.push(`${Constants.APP_URL_PREFIX}/dashboard`);
    }
    else {
      this.props.router.push(`${Constants.APP_URL_PREFIX}/login`);    	
    }
  }

  render() {
    return (
      <div>
        <div className="home">
        </div>     
      </div>
    );
  }
}

export default withRouter(Base);


// WEBPACK FOOTER //
// ./src/components/Home.js